import React from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { TextButton } from "@qgiv/core-donor";

const ParticipantCounterAddAnotherButton = ({
    addAdditionalAriaLabel,
    addParticipantLinkLabel,
    addRegistration,
    allowSubRegistrantToChangeRegRole,
    baseUrl,
    primaryRegistration,
    setAppShowRemainingForm,
    setAppShowRegistrationRole,
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { pathname } = location;
    const displayButtonBasedOnLocation =
        !pathname.includes("form/registration");

    const handleAddAnotherClick = () => {
        const registrationPageUrl = `${baseUrl}/form/registration`;
        // update redux with a dispatch
        // because we are loading the page fresh, we don't have
        // to worry about bringing in data from the parent registration
        // unless roles can not be different from primary
        const newRegistration = !allowSubRegistrantToChangeRegRole
            ? {
                  Team: primaryRegistration.Team,
                  Registration_Role: primaryRegistration.Registration_Role,
                  Needs_To_Be_Reviewed: false,
              }
            : {};

        dispatch(addRegistration(newRegistration));
        dispatch(setAppShowRegistrationRole(false));
        dispatch(setAppShowRemainingForm(false));

        // navigate to the registration page
        navigate(registrationPageUrl);
    };
    return displayButtonBasedOnLocation ? (
        <TextButton
            handleClick={handleAddAnotherClick}
            ariaLabel={addAdditionalAriaLabel}
        >
            <strong>{addParticipantLinkLabel}</strong>
        </TextButton>
    ) : null;
};

ParticipantCounterAddAnotherButton.propTypes = {
    addAdditionalAriaLabel: PropTypes.string.isRequired,
    addParticipantLinkLabel: PropTypes.string.isRequired,
    addRegistration: PropTypes.func.isRequired,
    allowSubRegistrantToChangeRegRole: PropTypes.bool.isRequired,
    baseUrl: PropTypes.string.isRequired,
    primaryRegistration: PropTypes.shape({
        Registration_Role: PropTypes.arrayOf(PropTypes.string),
        Team: PropTypes.string,
    }).isRequired,
    setAppShowRemainingForm: PropTypes.func.isRequired,
    setAppShowRegistrationRole: PropTypes.func.isRequired,
};

export default ParticipantCounterAddAnotherButton;
